import React from "react";
import { Counter } from "../ui/Counter";
import { Reveal } from "../ui/Reveal";
const PRINCIPLES = [{
  title: "No account managers",
  text: "You talk directly to the two senior builders designing and building your site."
}, {
  title: "Fixed price",
  text: "Your scope and price are agreed in writing before work begins. No surprise invoices."
}, {
  title: "No lock-in",
  text: "Hosting is month-to-month. Cancel anytime."
}, {
  title: "Built to perform",
  text: "Mobile-first, fast-loading and tested on every screen size."
}];
const NUMBERS = [{
  to: 600,
  prefix: "$",
  label: "One-time website build, from"
}, {
  to: 75,
  prefix: "$",
  suffix: "/mo",
  label: "Hosting & Maintenance"
}, {
  to: 2,
  label: "Senior builders on every project"
}, {
  to: 0,
  label: "Long-term contracts"
}];
export function WhyNexora() {
  return <section className="relative overflow-hidden border-t border-line bg-ink-2" data-id="element-220" data-mp="h9cuk42cubb1">
      <div className="grid-lines pointer-events-none absolute inset-0 opacity-70" aria-hidden data-id="element-221" data-mp="m2fo4c74tkr8" />
      <div className="shell section relative grid gap-[clamp(3rem,6vw,8rem)] lg:grid-cols-[1fr_1.1fr]" data-id="element-222" data-mp="rx8lrv8ho53i">
        <Reveal data-id="element-223" data-mp="mydsu0gt505o">
          <p className="t-eyebrow mb-5 flex items-center gap-3 text-accent-soft" data-id="element-224" data-mp="myxdvq1r84nx"><span className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-225" data-mp="10pix5fv4egmc" />Why NEXORA</p>
          <h2 className="t-h2 max-w-[14ch]" data-id="element-226" data-mp="vx91dj7bqmc5">A studio, not an agency.</h2>
          <dl className="mt-[clamp(2.5rem,4vw,5rem)] grid grid-cols-2 gap-x-6 gap-y-10" data-id="element-227" data-mp="vvxvndubj4ie">
            {NUMBERS.map(n => <div key={n.label} className="flex flex-col-reverse" data-id="element-228" data-mp="15o3osqwb3rz6">
                <dt className="mt-3 max-w-[22ch] text-[15px] text-muted" data-id="element-229" data-mp="15py860rxjc15">{n.label}</dt>
                <dd className="font-display text-[clamp(2.5rem,1.6rem+3vw,6rem)] font-semibold leading-none tracking-tight text-fg" data-id="element-230" data-mp="1jl9138mm5n2v">
                  <Counter to={n.to} prefix={n.prefix} suffix={n.suffix} data-id="element-231" data-mp="3legda96xjokj" />
                </dd>
              </div>)}
          </dl>
        </Reveal>
        <ul className="self-end border-t border-line-strong" data-id="element-232" data-mp="3hextxhurbljt">
          {PRINCIPLES.map((p, i) => <Reveal as="li" key={p.title} delay={i * 0.05} className="grid gap-2 border-b border-line py-[clamp(1.5rem,2.4vw,2.75rem)] sm:grid-cols-[minmax(180px,0.8fr)_1.2fr] sm:gap-8" data-id="element-233" data-mp="1kela2if1syuw" data-mpi={i}>
              <h3 className="t-h3" data-id="element-234" data-mp="1u93j8338hmm3">{p.title}</h3>
              <p className="t-body text-muted" data-id="element-235" data-mp="1z9hmz8xsyaeb">{p.text}</p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}